"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_2 = require("react");
const styles_1 = require("./styles");
const Tabs = (0, react_2.forwardRef)((props, ref) => {
    const { tabs, setSelectedTab, disabled, activeTab, inverted, height, fullWidth } = props;
    const WrapperComponent = !disabled
        ? !inverted
            ? styles_1.StyledDefaultTabItemWrapper
            : styles_1.StyledInvertedTabItemWrapper
        : styles_1.StyledDisabledTabItemWrapper;
    const tabItems = tabs.map(({ label, number }, index) => {
        return ((0, react_1.createElement)(WrapperComponent, { onClick: () => setSelectedTab(index), ...{ inverted, activeTab, height, fullWidth }, currentElement: index, alignItems: "flex-start", key: index, "data-testid": `tab-${index + 1}` },
            (0, jsx_runtime_1.jsxs)(styles_1.StyledTabItem, { flexDirection: "row", alignItems: "flex-start", justifyContent: "flex-start", fullWidth: true, fullHeight: true, ...{ inverted }, children: [(0, jsx_runtime_1.jsx)(styles_1.StyledTabLabel, { variant: "button", size: "normal", children: label }), number && ((0, jsx_runtime_1.jsx)(styles_1.StyledTabNumber, { justifyContent: "center", children: number }))] })));
    });
    return ((0, jsx_runtime_1.jsx)(styles_1.StyledTabs, { justifyContent: "space-between", alignItems: "flex-start", flexDirection: "row", fullHeight: true, ...{ ref, fullWidth }, children: tabItems }));
});
Tabs.displayName = 'Tabs';
exports.default = Tabs;
//# sourceMappingURL=tabs.js.map